
import Vue from "vue";
import { mixin as clickaway } from "vue-clickaway";
import { ContentLoader } from "vue-content-loader";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import Search2LineIcon from "~/assets/svg/heroicons/search-2-line.svg?inline=1";
import EqualizerLineIcon from "~/assets/svg/heroicons/equalizer-line.svg?inline=1";
import StoreInfoWindow from "~/components/StoreInfoWindow";
import closemobile from "~/assets/svg/closemobile.svg?inline=1";

export default {
  components: {
    Search2LineIcon,
    EqualizerLineIcon,
    ContentLoader,
    closemobile,
  },
  mixins: [clickaway],
  data() {
    return {
      // instances
      map: null,
      isMobileDrawer: false,
      isMobile: false,
      autocomplete: null,
      bounds: null,
      markerClusterer: null,
      // search
      place: {
        lat: null,
        lng: null,
      },
      isEmpty: false,
      searchQuery: "",
      distance: 50,
      distanceUnit: "km",
      services: [],
      distributorCategories: [],
      stores: [],
      selectedStore: null,
      markers: [],
      isLoading: true,
      isFetching: false,
      infoWindows: [],
      tabs: [
        this.$t("common.all"),
        this.$t("common.store"),
        this.$t("common.service"),
      ],
      isDropdownOpen: false,
      activetab: "km",
      servicesList: [],
    };
  },
  mounted() {
    if (window.innerWidth >= 768) {
      this.isMobileDrawer = false;
      this.isMobile = false;
    } else {
      this.isMobile = true;
    }

    if (!process.browser) {
      return;
    }
    this.$loadGoogleMaps().then(() => {
      // Bind Map
      this.map = new window.google.maps.Map(this.$refs.map, {
        mapId: "bb21f8f7be75a8ab",
        center: {
          lat: parseFloat("43.112334"),
          lng: parseFloat("12.594401"),
        },
        maxZoom: 22,
        zoom: 1,
        mapTypeId: window.google.maps.MapTypeId.ROADMAP,
        mapTypeControlOptions: {
          position: window.google.maps.ControlPosition.BOTTOM_RIGHT,
          mapTypeIds: [
            window.google.maps.MapTypeId.ROADMAP,
            window.google.maps.MapTypeId.SATELLITE,
          ],
        },
        scaleControl: true,
        streetViewControl: false,
        rotateControl: true,
        fullscreenControlOptions: {
          position: window.google.maps.ControlPosition.BOTTOM_RIGHT,
        },
      });

      // this.map.setPadding(400, 100, 100, 100)

      let restriction = {};

      if (this.$store.state.country !== "int") {
        restriction = {
          componentRestrictions: {
            country: this.$store.state.country,
          },
        };
      }
      // Bind Autocomplete
      this.autocomplete = new window.google.maps.places.Autocomplete(
        this.$refs.autocomplete,
        {
          // types: ['geocode'],
          fields: ["formatted_address", "geometry", "name"],
          ...restriction,
        }
      );
      this.addGeoLocationButton();
      this.bounds = new window.google.maps.LatLngBounds();
      this.autocomplete.bindTo("bounds", this.map);
      this.autocomplete.addListener("place_changed", () => {
        this.$toast.clear();

        const place = this.autocomplete.getPlace();
        if (!place.geometry) {
          if (this.searchQuery === "") {
            this.resetState();
          } else {
            this.$toast.show(this.$t("common.no_search_results_found"));
          }
          return;
        }

        this.$nextTick(() => {
          this.place = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
          };
          // this.searchQuery = place.name + ' ' + place.formatted_address
          this.searchPlace();
        });
      });
      this.$nextTick(() => {
        setTimeout(() => {
          this.updateIcons();
        }, 2500);
      });

      window.onresize = this.reportWindowSize;
      this.setCompanyCenter();
    });
  },
  methods: {
    onToggleDrawer() {
      this.isMobileDrawer = !this.isMobileDrawer;
    },
    onOpenDrawer() {
      if (this.isMobile) {
        this.isMobileDrawer = true;
      }
    },
    onSwitchDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
      if (this.isMobile) {
        this.isMobileDrawer = true;
      }
    },
    onSearch(e) {
      this.searchQuery = e.target.value;

      if (!this.searchQuery) {
        this.isEmpty = true;
        this.resetState();
      } else {
        this.isEmpty = false;
      }
    },
    searchPlaceWithFill(data) {
      if (!this.searchQuery) {
        this.isEmpty = true;
        return;
      }
      this.isEmpty = false;
      this.searchPlace(data);
    },
    away() {
      this.isEmpty = false;
      this.isDropdownOpen = false;
    },
    addGeoLocationButton() {
      const locationButton = document.createElement("button");

      locationButton.textContent = "";
      locationButton.classList.add("custom-map-control-button");
      this.map.controls[window.google.maps.ControlPosition.RIGHT_BOTTOM].push(
        locationButton
      );
      locationButton.addEventListener("click", () => {
        // Try HTML5 geolocation.
        this.getCurrentPosition();
      });
    },
    handleLocationError(browserHasGeolocation, infoWindow, pos) {
      infoWindow.setPosition(pos);
      infoWindow.setContent(
        browserHasGeolocation
          ? this.$t("common.error_geolocation_service")
          : this.$t("common.error_geolocation_not_support")
      );
      infoWindow.open(this.map);
    },
    storeInfoCurrentTab(tab) {
      if (tab === "Store") {
        this.distributorCategories = ["point_of_sale"];
      } else if (tab === "Service") {
        this.distributorCategories = ["service_center"];
      } else if (tab === "All") {
        this.distributorCategories = [];
      }
      this.onOpenDrawer();

      this.searchPlace({ use_distance: this.searchQuery.length > 0 });
    },
    updateIcons() {
      const elMapIcon = document.getElementsByClassName("gm-style-mtc")[0];
      const elGeolocationIcon = document.getElementsByClassName(
        "custom-map-control-button"
      )[0];

      if (elMapIcon && elMapIcon.firstChild) {
        elMapIcon.firstChild.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1991_63721)">
            <path d="M1.66797 4.16669L7.5013 1.66669L12.5013 4.16669L17.7538 1.91585C17.8172 1.88867 17.8864 1.87766 17.9551 1.88381C18.0238 1.88995 18.0899 1.91306 18.1475 1.95106C18.2051 1.98906 18.2523 2.04076 18.285 2.10152C18.3176 2.16228 18.3347 2.2302 18.3346 2.29919V15.8334L12.5013 18.3334L7.5013 15.8334L2.2488 18.0842C2.1854 18.1114 2.11623 18.1224 2.04752 18.1162C1.97881 18.1101 1.9127 18.087 1.85512 18.049C1.79755 18.011 1.75031 17.9593 1.71764 17.8985C1.68498 17.8378 1.66791 17.7698 1.66797 17.7009V4.16669ZM12.5013 16.47V5.98002L12.4471 6.00335L7.5013 3.53002V14.02L7.55547 13.9967L12.5013 16.47Z" fill="#747474"/>
            </g>
            <defs>
            <clipPath id="clip0_1991_63721">
            <rect width="20" height="20" fill="white"/>
            </clipPath>
            </defs>
            </svg>`;
      }
      if (elGeolocationIcon) {
        elGeolocationIcon.classList.add("active");
        elGeolocationIcon.innerHTML = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.619741 6.76249C0.184741 6.61749 0.180575 6.38333 0.628075 6.23416L16.5339 0.932493C16.9747 0.785826 17.2272 1.03249 17.1039 1.46416L12.5589 17.3692C12.4339 17.81 12.1797 17.825 11.9931 17.4067L8.99807 10.6667L13.9981 3.99999L7.33141 8.99999L0.619741 6.76249Z" fill="#747474"/>
              </svg>`;
      }
    },
    reportWindowSize(e) {
      if (window.innerWidth >= 768) {
        this.isMobileDrawer = false;
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
      setTimeout(() => {
        this.updateIcons();
      }, 200);
    },

    activeTabMethod(currentTab) {
      this.activetab = currentTab;
      this.distanceUnit = this.activetab;
      if (!this.searchQuery) {
        this.isEmpty = true;
      } else {
        this.isEmpty = false;
      }
      this.searchPlace({ use_distance: this.searchQuery.length > 0 });
    },
    toggleService(serviceKey) {
      const existsIndex = this.services.indexOf(serviceKey);
      if (existsIndex === -1) {
        this.services.push(serviceKey);
      } else {
        this.services.splice(existsIndex, 1);
      }

      this.searchPlace({ use_distance: this.searchQuery.length > 0 });
    },
    setCompanyCenter() {
      // Infinite budget for Googe Maps API?
      const hasInfiniteBudget = "🤣";
      if (hasInfiniteBudget === "🤣") {
        this.place = {
          lat: parseFloat(this.$store.state.currentSite.country.country_lat),
          lng: parseFloat(this.$store.state.currentSite.country.country_long),
        };

        this.searchPlace({ use_distance: false });
      } else {
        // money-wise guy.
        this.setDefaultMapCenter();
      }
    },
    isGeoEnabled() {
      if (!process.browser) {
        return false;
      }

      return "geolocation" in navigator;
    },

    getCurrentPosition() {
      if (!this.isGeoEnabled()) {
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const geocoder = new window.google.maps.Geocoder();
          return geocoder.geocode(
            {
              location: new window.google.maps.LatLng(
                position.coords.latitude,
                position.coords.longitude
              ),
            },
            (results, status) => {
              if (status === window.google.maps.GeocoderStatus.OK) {
                this.place = {
                  lat: position.coords.latitude,
                  lng: position.coords.longitude,
                };
                this.searchPlace();
                this.searchQuery = results[0].formatted_address;
                // console.log(results[0].formatted_address)
              }
            }
          );
        },
        (error) => {
          if (error.code === error.PERMISSION_DENIED) {
            this.setDefaultMapCenter();
          }
        },
        {
          timeout: 70000,
          enableHighAccuracy: true,
          maximumAge: 75000,
        }
      );
    },

    setDefaultMapCenter(coords, zoom = 5) {
      this.map.setCenter({
        lat: parseFloat(this.$store.state.currentSite.country.country_lat),
        lng: parseFloat(this.$store.state.currentSite.country.country_long),
      });

      this.map.setZoom(zoom);
    },

    setMapCenter(place, zoom = 5) {
      const position = new window.google.maps.LatLng(
        parseFloat(place.lat),
        parseFloat(place.lng)
      );
      if (!isNaN(position.lat()) || !isNaN(position.lng())) {
        this.map.setCenter(position);
      }
      this.map.setZoom(zoom);
    },

    addMarker(data) {
      const position = new window.google.maps.LatLng(
        parseFloat(data.position.lat),
        parseFloat(data.position.lng)
      );

      if (isNaN(position.lat()) || isNaN(position.lng())) {
        console.warn("☢️ wrong position");
        console.table(data);
        return;
      }

      // add marker
      const marker = new window.google.maps.Marker({
        position,
        map: this.map,
        icon: {
          url: require("~/assets/images/ellipse.png"),
          scaledSize: new window.google.maps.Size(18, 18),
        },
      });

      this.bounds.extend(marker.position);

      const StoreInfoWindowCmp = Vue.extend(StoreInfoWindow);
      const StoreInfoWindowInstance = new StoreInfoWindowCmp({
        parent: this,
        propsData: {
          distance: data.distance,
          info: data.info,
          position: data.position,
          showDetail: true,
        },
      }).$mount();

      const infoWindow = new window.google.maps.InfoWindow({
        content: StoreInfoWindowInstance.$el,
      });

      this.markers.push(marker);
      this.infoWindows.push(infoWindow);

      marker.addListener("click", () => {
        this.closeInfoWindows();
        infoWindow.open(this.map, marker);
        this.setMapCenter(marker.getPosition(), 15);
      });
    },

    closeInfoWindows() {
      this.infoWindows.forEach((info, index) =>
        info.close(this.map, this.markers[index])
      );
    },

    goToMarker(index) {
      this.isMobileDrawer = false;
      if (index === this.selectedStore) {
        return;
      }

      this.closeInfoWindows();

      this.infoWindows[index].open(this.map, this.markers[index]);
      this.setMapCenter(this.markers[index].getPosition(), 15);

      this.selectedStore = index;
    },

    resetData() {
      // reset bounds
      this.bounds = new window.google.maps.LatLngBounds();

      // clear infowindow
      this.closeInfoWindows();
      this.infoWindows = [];

      if (this.markerClusterer) {
        this.markerClusterer.clearMarkers();
      }

      // clear markers
      this.markers.forEach((marker, index) => marker.setMap(null));
      this.markers = [];

      // reset stores
      this.stores = [];
      this.selectedStore = null;
    },

    resetState() {
      this.searchQuery = "";
      this.setCompanyCenter();
      this.searchPlace();
    },

    async searchPlace(params) {
      if (this.isFetching) return false;
      this.resetData();
      try {
        this.isLoading = true;
        this.isFetching = true;

        const res = await this.$axios.$get("/api/front/stores/services");
        this.servicesList = res;

        const { data } = await this.$axios.$get("/api/front/stores/v2", {
          params: Object.assign(
            {
              distance: this.distance,
              distance_unit: this.distanceUnit,
              lat: this.place.lat,
              lng: this.place.lng,
              services: this.services,
              use_distance: true,
              distributor_categories: this.distributorCategories,
            },
            params
          ),
        });
        this.stores = data;

        this.setMapCenter(this.place);

        this.stores.forEach((store) =>
          setTimeout(() => this.addMarker(store), 5)
        );

        setTimeout(() => {
          this.isLoading = false;
          this.isFetching = false;
          if (this.markers.length > 0) {
            this.map.fitBounds(this.bounds);

            // use default algorithm and renderer
            // this.markerClusterer = new MarkerClusterer({ markers: this.markers, map: this.map })
            const renderer = {
              render({ count, position }, stats, map) {
                // change color if this cluster has more markers than the mean cluster
                const color =
                  count > Math.max(10, stats.clusters.markers.mean)
                    ? "#228f61"
                    : "#13B973";
                // create svg literal with fill color
                const svg = `<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
<circle cx="120" cy="120" opacity=".6" r="70" />
<circle cx="120" cy="120" opacity=".3" r="90" />
<circle cx="120" cy="120" opacity=".2" r="110" />


<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${count}</text>
</svg>`;
                const title = `Cluster of ${count} markers`,
                  // adjust zIndex to be above other markers
                  zIndex = Number(google.maps.Marker.MAX_ZINDEX) + count;

                const clusterOptions = {
                  position,
                  zIndex,
                  title,
                  icon: {
                    url: `data:image/svg+xml;base64,${btoa(svg)}`,
                    anchor: new google.maps.Point(25, 25),
                  },
                };
                return new google.maps.Marker(clusterOptions);
              },
            };
            this.markerClusterer = new MarkerClusterer({
              markers: this.markers,
              map: this.map,
              renderer: renderer,
            });
          }
        }, 10);
      } catch (error) {
        console.error(error);
      }
    },
  },
  head() {
    return { title: this.$t("common.stores_and_inventories") };
  },
};
